import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useSearchParams } from "react-router-dom";
import Teams from "./Teams";
import AllProviders from "./AllProviders";

const CareTeamList = () => {
  const [params] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState('')
  const [toggleTab, setToggleTab] = useState("All Provider");

  const handleToggleChange = (tab) => {
    setToggleTab(tab);
  };
  return (
    <>
      <div className="d-flex mt-3 mb-3">
        <div className="w-100">
          <div className="actsearch_simple shadow-sm me-2">
            <FiSearch className="boxicon" />
            <input
              placeholder={`Search ${toggleTab === 'All Provider' ? 'Provider Name' : 'Care Team Name'} here...`}
              className="ms-2"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* <Tabs
        selectedIndex={selectedTab}
        onSelect={(index) => setSelectedTab(index)}
      >
        <TabList>
          <Tab>Teams </Tab>
          <Tab>All Providers</Tab>
        </TabList>
        <TabPanel>
          <Teams />
        </TabPanel>
        <TabPanel>
          <AllProviders />
        </TabPanel>
      </Tabs> */}

      <div
        className="btn-group mb-3"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio1"
          autoComplete="off"
          defaultChecked
          onChange={() => handleToggleChange("All Provider")}
        />
        <label
          className="btn border-0"
          style={{
            backgroundColor:
              toggleTab === "Teams"
                ? "rgba(255, 255, 255, 1)"
                : "rgba(225, 228, 230, 1)",
            padding: "10px 100px",
            boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.05)",
          }}
          htmlFor="btnradio1"
        >
          All Providers
        </label>
        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio2"
          autoComplete="off"
          onChange={() => handleToggleChange("Teams")}
        />
        <label
          className="btn border-0"
          style={{
            backgroundColor:
              toggleTab === "All Provider"
                ? "rgba(255, 255, 255, 1)"
                : "rgba(225, 228, 230, 1)",
            padding: "10px 100px",
            boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.05)",
          }}
          htmlFor="btnradio2"
        >
          Teams
        </label>
      </div>
      {toggleTab === "All Provider" && <AllProviders searchTerm={searchTerm} />}
      {toggleTab === "Teams" && <Teams searchTerm={searchTerm}/>}
    </>
  );
};

export default CareTeamList;
